<div class="card mt-3">
  <div class="card-header text-uppercase">Histórico de Boletas</div>

  <div class="card-body">
    <div class="row mb-2">
      <div class="col-12">
        <div class="row mb-2">
          <div class="col" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="starDate"
                [matDatepicker]="picker"
                placeholder="Período de"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoAte"
                [(ngModel)]="endDate"
                [matDatepicker]="picker2"
                placeholder="Até"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field>
              <mat-label>Tipos de Boletas</mat-label>
              <mat-select [(ngModel)]="ticketTypeFilter" name="ticektTypes">
                <mat-option [value]="null"> (todas) </mat-option>
                <mat-option *ngFor="let item of TicketTypes" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <input
              style="width: 100%; margin-top: 7px"
              type="button"
              value="Buscar"
              data-cy="submit"
              class="btn btn-primary"
              appDebounceClick
              (debounceClick)="getReceivables()"
              [debounceTime]="200"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-12">
      <mat-table #table [dataSource]="dataSource">
        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->
        <!-- Symbol Column -->
        <ng-container matColumnDef="fileName">
          <mat-header-cell *matHeaderCellDef> Arquivo </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div>
              <a (click)="download(element.fileName)">
                <fa-icon
                  [icon]="faDownload"
                  style="padding-right: 10px"
                ></fa-icon>
                <!-- <i title="Download" class="fas fa-download fa-lg" style="color:blue"></i> -->
              </a>
            </div>
          </mat-cell>
        </ng-container>
        <!-- Position Column -->
        <ng-container matColumnDef="userName">
          <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.userName }}
          </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="createDate">
          <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.createDate | date: "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="ticketType">
          <mat-header-cell *matHeaderCellDef> Tipo boleta </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.ticketType }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <paginador
        [listedPages]="listedPages"
        [firstItemOnPage]="firstItemOnPage"
        [lastItemOnPage]="lastItemOnPage"
        [totalPages]="totalPages"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [itemsPerPage]="[10, 25, 50, 100, 200]"
        (onSearch)="getReceivables($event[0], $event[1])"
      ></paginador>
    </div>
  </div>
</div>
